module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/mobile/1.png?7b560a0ca1af2293544e9c494fc5e6ba";